import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DocumentService } from '../../providers/document.service';
import { DownloaderHelper } from '../../helpers/downloader.helper';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Athlete } from "../../../common/models/athlete";
import { Organization } from "../../../common/models/organization";
import { Document } from "../../../common/models/document";
import { TranslateModule } from "@ngx-translate/core";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { NgForOf, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";
import { MatIconButton, MatMiniFabButton } from "@angular/material/button";
import { MatLine } from "@angular/material/core";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatList, MatListItem, MatListModule } from "@angular/material/list";
import { User } from "../../../common/models/user";

@Component({
  selector: 'app-document-upload',
  templateUrl: './upload.component.html',
  standalone: true,
  imports: [
    TranslateModule,
    AppDatePipe,
    NgIf,
    RouterLink,
    NgForOf,
    MatMiniFabButton,
    MatIconButton,
    MatLine,
    MatIcon,
    MatTooltip,
    MatProgressSpinner,
    MatListModule,
  ],
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit, OnDestroy {
    public isLoading = true;

    public paginator: any;

    @Input()
    public organization: Organization | null = null;

    @Input()
    public athleteUser: User = {} as User;

    private subscriptions: Subscription[] = [];

    constructor(
        public dialog: MatDialog,
        private documentService: DocumentService
    ) {

    }

    public ngOnInit(): void {
        this.loadDocuments();
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public download(d: Document) {
        this.subscriptions.push(
            this.documentService.download(this.organization!, this.athleteUser.athlete!, d).subscribe((response: Blob) => {
                DownloaderHelper.forceDownload(response, d.originalName?? 'document');
            })
        );
    }

    private loadDocuments() {
        this.subscriptions.push(
            this.documentService.getByAthlete(this.organization!, this.athleteUser.athlete!).subscribe((paginator: any) => {
                this.paginator = paginator;
                this.isLoading = false;
            })
        );
    }
}
